<template>
    <v-container fill-height fluid pa-0>
        <v-row align="center" class="fill-height" justify="start">
            <template v-if="mode==='static' || isCurrentMeasureFirstInPhase">
                <journey-progress-bar :current-phase="currentPhase"
                                      mode="static"
                                      active
                ></journey-progress-bar>
            </template>
            <template v-else-if="mode==='in' && currentPhase">
                <journey-progress-bar :current-phase="currentPhase"
                                      mode="in"
                                      active
                ></journey-progress-bar>
            </template>
        </v-row>
    </v-container>
</template>

<script>
    import JourneyProgressBar from "../journey/JourneyProgressBar";
    import soundController from "../../lib/soundController";
    export default {
        name: "JourneyPhaseProgress",
        components: {
            JourneyProgressBar
        },
        props: {
            mode: {
                type: String,
                default: 'static'
            },
            animate: {
                type: Number,
                default: 0
            }
        },
        computed: {
            isCurrentMeasureFirstInPhase() {
                return this.$store.getters['assessment/isCurrentMeasureFirstInPhase'];
            },
            currentPhaseId() {
                return this.$store.state.assessment.journeyplan.journeyphaseid;
            },
            currentPhase() {
                return this.$store.state.journey.journey.journeyphases.find((phase) => phase.journeyphaseid === this.currentPhaseId);
            },
        },
        mounted() {
            if (this.animate) {
                this.startAnimation();
            }
        },
        methods: {
            startAnimation() {
                if(this.mode==='in' && !this.isCurrentMeasureFirstInPhase)
                  soundController.achievement();
                //Todo: start animation here and run animationComplete when it is.
                setTimeout(() => {
                    this.animationComplete();
                }, this.animate);
            },
            animationComplete() {
                this.$emit('complete');
            }
        }
    }
</script>

<style scoped>

</style>